module.exports = __webpack_public_path__ + "static/cosmos-social-51b5fc59d3fb12544bbaf2e0fa61884b.jpg";